<template>
    <app-layout title="Dashboard">

        <div class="pt-8 px-8">
            <div class="flex gap-x-4">
                <!-- <div class="flex flex-1">
                    <div>
                        <h2>Recent Orders</h2>


                    </div>
                </div> -->

                <div class="flex flex-1">
                    <div>
                        <h2>Announcements</h2>

                        <ol class="pt-4 pl-4 list-decimal">
                            <announcement
                                v-for="(announcement) in announcements"
                                :key="announcement.id"
                                :announcement="announcement"
                                class="mb-6"
                            />
                        </ol>

                        <div v-show="!announcements.length" class="pt-4">
                            No current announcements.
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Announcement from '@/Shared/Announcement.vue';

    export default {
        components: {
            AppLayout,
            Announcement,
        },

        props:['announcements'],

        computed: {
            activeCustomer() {
                return this.$page.props.activeCustomer;
            },
        },
    }
</script>
